import { Box, Typography } from '@mui/material';
import React from 'react';
import CustomerInfos from '../Retractions/CustomerInfos';
import SetAddress from '../Sav/SavAddress.jsx';

const StepOne = ({ formData, handleFormChange, formError, ticket }) => {
  return (
    <Box sx={{ p: 2 }}>
      <Typography variant="h6" component="div">
        Informations personnelles du client
      </Typography>
      <CustomerInfos
        formData={formData}
        handleFormChange={handleFormChange}
        formError={formError}
      />
      <SetAddress
        formData={formData}
        orderDetails={null}
        handleFormChange={handleFormChange}
        formError={formError}
        addressName="billing"
        ticket={ticket}
      />
    </Box>
  );
};

export default StepOne;
